export const tourData = {
  talk1: {
    title: "Grand City Art Museum Tour",
    type: "tour",
    versions: {
      basic: {
        script: `Welcome to the Grand City Art Museum. We are pleased to have you join today's <mark>guided tour of our newest exhibition</mark>.
        <mark>Our first stop is the Renaissance Gallery</mark>, which features <mark>paintings from the 15th and 16th centuries</mark>, including works by Michelangelo and Leonardo da Vinci. Many of these pieces have been carefully restored to preserve their original beauty.
        During the tour, you will notice <mark>information plaques</mark> next to each painting. Feel free to read them to learn more about the history and techniques used by the artists. Also, please remember that flash photography is not allowed, as it can damage the artwork.
        Now, let's begin our tour.`,
        translation: `그랜드 시티 미술관에 오신 것을 환영합니다. 오늘 저희의 최신 전시회 가이드 투어에 참여해 주셔서 기쁩니다.
        첫 번째 관람 장소는 르네상스 갤러리입니다. 이곳에는 미켈란젤로와 레오나르도 다빈치의 작품을 포함한 15세기와 16세기의 그림들이 전시되어 있습니다. 이 작품들 중 대부분은 원래의 아름다움을 보존하기 위해 세심하게 복원되었습니다.
        투어 중에 각 그림 옆에 있는 안내판을 보실 수 있습니다. 예술가들이 사용한 역사와 기법에 대해 더 자세히 알고 싶으시다면 자유롭게 읽어보시기 바랍니다. 또한 플래시 사진 촬영은 작품을 손상시킬 수 있으므로 금지되어 있음을 기억해 주시기 바랍니다.
        이제 투어를 시작하겠습니다.`,
        audioUrl: {
          us: "audios/part4/tour/us/us1.mp3",
          uk: "audios/part4/tour/uk/uk1.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the main topic of the announcement?",
        options: {
          A: "The opening of a <mark>new</mark> <mark>museum</mark>",
          B: "A <mark>guided tour</mark> of an <mark>art exhibition</mark>",
          C: "A lecture on <mark>Renaissance artists</mark>",
          D: "The history of <mark>painting restoration</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 새로운 박물관의 개장
B: 미술 전시회의 가이드 투어
C: 르네상스 예술가들에 대한 강의
D: 그림 복원의 역사

정답 B: 스크립트의 "guided tour of our newest exhibition"에서 알 수 있듯이, 이 안내방송은 미술관의 전시회 가이드 투어에 관한 것입니다.`,
      },
      {
        id: 2,
        question:
          "What does the speaker say about the <mark>Renaissance Gallery</mark>?",
        options: {
          A: "It includes <mark>paintings from the 15th and 16th centuries</mark>",
          B: "It displays sculptures from <mark>ancient Greece</mark>",
          C: "It features <mark>modern</mark> <mark>digital artwork</mark>",
          D: "It allows visitors to <mark>touch</mark> some <mark>paintings</mark>",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 15세기와 16세기의 그림들을 포함하고 있다
B: 고대 그리스의 조각품들을 전시하고 있다
C: 현대 디지털 예술작품을 특징으로 한다
D: 방문객들이 일부 그림을 만질 수 있다

정답 A: 스크립트의 "paintings from the 15th and 16th centuries"에서 르네상스 갤러리가 15-16세기의 그림들을 전시한다고 직접적으로 언급하고 있습니다.`,
      },
      {
        id: 3,
        question: "What does the speaker remind visitors to do?",
        options: {
          A: "Read the <mark>information plaques</mark> for more information",
          B: "Take <mark>pictures</mark> of the paintings",
          C: "Ask the tour guide about <mark>restoration techniques</mark>",
          D: "Visit the museum <mark>gift shop</mark> after the tour",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 더 많은 정보를 위해 안내판을 읽기
B: 그림들의 사진을 찍기
C: 복원 기술에 대해 가이드에게 질문하기
D: 투어 후 박물관 기념품점 방문하기

정답 A: 스크립트의 "information plaques next to each painting. Feel free to read them"에서 방문객들에게 안내판을 읽으라고 상기시키고 있습니다.`,
      },
    ],
  },
  talk2: {
    title: "National History Museum Tour",
    type: "tour",
    versions: {
      basic: {
        script: `Welcome to the National History Museum. We are excited to have you join <mark>today's tour of one of our most famous exhibits</mark>.
        This section of the museum is dedicated to prehistoric life, showcasing fossils from various time periods. Among them is the skeleton of a giant marine reptile, which was discovered just five years ago. <mark>Visitors will also see ancient plants preserved in stone</mark>.
        As we move through the exhibit, you'll notice <mark>interactive touchscreens placed next to certain fossils</mark>. Feel free to use them to learn about the age and origin of each specimen. Also, to protect these delicate artifacts, please do not touch any displays.
        Let's begin our tour.`,
        translation: `국립 역사 박물관에 오신 것을 환영합니다. 오늘 저희의 가장 유명한 전시물 중 하나를 둘러보는 투어에 참여해 주셔서 기쁩니다.
        박물관의 이 구역은 선사 시대의 생명체를 소개하며, 다양한 시대의 화석들을 전시하고 있습니다. 그 중에는 5년 전에 발견된 거대 해양 파충류의 골격이 있습니다. 방문객들은 또한 돌 속에 보존된 고대 식물들도 보실 수 있습니다.
        전시물을 둘러보시다 보면 특정 화석 옆에 설치된 인터랙티브 터치스크린을 보실 수 있습니다. 각 표본의 연대와 기원에 대해 알아보시려면 자유롭게 사용하시기 바랍니다. 또한 이 섬세한 유물들을 보호하기 위해 전시물을 만지지 말아주시기 바랍니다.
        이제 투어를 시작하겠습니다.`,
        audioUrl: {
          us: "audios/part4/tour/us/us2.mp3",
          uk: "audios/part4/tour/uk/uk2.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the main purpose of the announcement?",
        options: {
          A: "To explain the history of <mark>marine reptiles</mark>",
          B: "To <mark>guide visitors</mark> through a museum <mark>exhibit</mark>",
          C: "To introduce a new museum <mark>director</mark>",
          D: "To announce a <mark>fossil discovery</mark> event",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 해양 파충류의 역사를 설명하기 위해
B: 박물관 전시를 통해 방문객들을 안내하기 위해
C: 새로운 박물관 관장을 소개하기 위해
D: 화석 발견 행사를 알리기 위해

정답 B: 스크립트의 "today's tour of one of our most famous exhibits"에서 알 수 있듯이, 이 안내는 박물관 전시 투어를 위한 것입니다.`,
      },
      {
        id: 2,
        question: "What does the speaker say about the exhibit?",
        options: {
          A: "It includes <mark>fossils of ancient plants</mark>",
          B: "It is only open on <mark>weekends</mark>",
          C: "It was recently <mark>renovated</mark>",
          D: "It features modern <mark>sculptures</mark>",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 고대 식물의 화석들을 포함하고 있다
B: 주말에만 개방한다
C: 최근에 보수되었다
D: 현대 조각품들을 전시한다

정답 A: 스크립트의 "Visitors will also see ancient plants preserved in stone"에서 전시관에 고대 식물 화석이 있다고 언급하고 있습니다.`,
      },
      {
        id: 3,
        question: "What does the speaker encourage visitors to do?",
        options: {
          A: "Use <mark>touchscreens</mark> to learn about fossils",
          B: "Ask <mark>questions</mark> at the end of the tour",
          C: "Take <mark>pictures</mark> of the exhibits",
          D: "Touch the <mark>fossils</mark> carefully",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 화석에 대해 배우기 위해 터치스크린을 사용하기
B: 투어가 끝난 후 질문하기
C: 전시품의 사진 찍기
D: 화석을 조심스럽게 만지기

정답 A: 스크립트의 "interactive touchscreens placed next to certain fossils... use them to learn about the age and origin of each specimen"에서 방문객들에게 터치스크린 사용을 권장하고 있습니다.`,
      },
    ],
  },
  talk3: {
    title: "Factory Tour",
    type: "tour",
    versions: {
      basic: {
        script: `Welcome to Summit Electronics Manufacturing, one of the leading producers of home appliances. <mark>Today's tour will give you a behind-the-scenes look at how our products are made</mark>.
        First, we will visit the assembly line, where technicians carefully put together each component. Every product undergoes multiple quality checks before being packed for shipment.
        Next, we will move to the <mark>testing facility</mark>, <mark>where our engineers ensure that each appliance meets industry safety standards</mark>. Please note that for safety reasons, <mark>visitors must wear protective eyewear and remain in designated areas at all times</mark>.
        If you have any questions, feel free to ask at the end of the tour. Now, let's begin.`,
        translation: `서밋 전자 제조사에 오신 것을 환영합니다. 저희는 가전제품의 선두 제조업체 중 하나입니다. 오늘 투어에서는 제품이 어떻게 만들어지는지 현장을 직접 보실 수 있습니다.
        먼저, 기술자들이 각 부품을 조심스럽게 조립하는 조립 라인을 방문할 예정입니다. 모든 제품은 출하를 위해 포장되기 전에 여러 차례의 품질 검사를 거칩니다.
        다음으로, 엔지니어들이 각 가전제품이 산업 안전 기준을 충족하는지 확인하는 테스트 시설로 이동하겠습니다. 안전상의 이유로 방문객들은 보호 안경을 착용하고 지정된 구역에만 머물러야 함을 유의해 주시기 바랍니다.
        질문이 있으시다면 투어가 끝난 후에 자유롭게 해주시기 바랍니다. 이제 시작하겠습니다.`,
        audioUrl: {
          us: "audios/part4/tour/us/us3.mp3",
          uk: "audios/part4/tour/uk/uk3.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the purpose of the tour?",
        options: {
          A: "To introduce a <mark>new</mark> company <mark>policy</mark>",
          B: "To train employees on <mark>safety procedures</mark>",
          C: "To show how <mark>products are manufactured</mark>",
          D: "To discuss the company's <mark>financial</mark> <mark>growth</mark>",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: 새로운 회사 정책을 소개하기 위해
B: 직원들에게 안전 절차를 교육하기 위해
C: 제품이 어떻게 제조되는지 보여주기 위해
D: 회사의 재정적 성장을 논의하기 위해

정답 C: 스크립트의 "Today's tour will give you a behind-the-scenes look at how our products are made"에서 이 투어의 목적이 제품 제조 과정을 보여주는 것임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question:
          "What does the speaker say about the <mark>testing facility</mark>?",
        options: {
          A: "It has recently been <mark>renovated</mark>",
          B: "It ensures appliances meet <mark>safety standards</mark>",
          C: "It is open to visitors <mark>only</mark> on <mark>weekends</mark>",
          D: "It is used for employee <mark>training</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 최근에 보수되었다
B: 가전제품이 안전 기준을 충족하는지 확인한다
C: 주말에만 방문객에게 개방된다
D: 직원 교육을 위해 사용된다

정답 B: 스크립트의 "where our engineers ensure that each appliance meets industry safety standards"에서 테스트 시설이 제품의 안전 기준 충족 여부를 확인한다고 명시하고 있습니다.`,
      },
      {
        id: 3,
        question: "What are visitors required to do?",
        options: {
          A: "<mark>Stay</mark> close to the <mark>machines</mark>",
          B: "Wear <mark>protective eyewear</mark>",
          C: "Take <mark>notes</mark> during the tour",
          D: "Ask <mark>questions</mark> throughout the tour",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 기계 근처에 머물기
B: 보호 안경 착용하기
C: 투어 중 메모하기
D: 투어 중 질문하기

정답 B: 스크립트의 "visitors must wear protective eyewear and remain in designated areas at all times"에서 방문객들이 보호 안경을 착용해야 한다고 명시하고 있습니다.`,
      },
    ],
  },

  talk4: {
    title: "Campus Tour",
    type: "tour",
    versions: {
      basic: {
        script: `Welcome to Brighton University! My name is Lisa, and I'll be your guide for today's campus tour. This tour is designed to help <mark>new students become familiar with our campus</mark> and its key facilities.
        First, we'll visit the <mark>Main Library</mark>, which has four floors and offers <mark>private study rooms, research databases, and free academic tutoring</mark>. Then, we'll head to the Student Center, where you can find the cafeteria, bookstore, and lounge areas.
        As we walk, feel free to ask any questions. Also, remember that <mark>campus maps are available at the information desk</mark> if you need them.
        Now, let's begin our tour.`,
        translation: `브라이튼 대학에 오신 것을 환영합니다! 제 이름은 리사이고, 오늘 캠퍼스 투어를 안내해 드리겠습니다. 이 투어는 신입생들이 우리 캠퍼스와 주요 시설들에 익숙해지도록 돕기 위해 마련되었습니다.
        먼저, 4층 규모의 중앙도서관을 방문할 예정입니다. 이곳에는 개인 학습실, 연구 데이터베이스, 무료 학업 튜터링이 제공됩니다. 그 다음, 구내식당, 서점, 라운지 공간이 있는 학생회관으로 이동하겠습니다.
        투어 중에 궁금한 점이 있으시면 언제든 질문해 주세요. 또한 필요하신 경우 안내 데스크에서 캠퍼스 지도를 받으실 수 있다는 점도 기억해 주시기 바랍니다.
        이제 투어를 시작하겠습니다.`,
        audioUrl: {
          us: "audios/part4/tour/us/us4.mp3",
          uk: "audios/part4/tour/uk/uk4.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "Who is this tour intended for?",
        options: {
          A: "University <mark>alumni</mark>",
          B: "<mark>New students</mark>",
          C: "Visiting <mark>professors</mark>",
          D: "Campus <mark>staff</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 대학 졸업생들
B: 신입생들
C: 방문 교수들
D: 캠퍼스 직원들

정답 B: 스크립트의 "This tour is designed to help new students become familiar with our campus"에서 이 투어가 신입생들을 위한 것임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What is mentioned about the <mark>Main Library</mark>?",
        options: {
          A: "It provides <mark>private study rooms</mark>",
          B: "It offers <mark>24-hour access</mark>",
          C: "It has a <mark>technology training center</mark>",
          D: "It will be under <mark>renovation</mark> soon",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 개인 학습실을 제공한다
B: 24시간 이용이 가능하다
C: 기술 교육 센터가 있다
D: 곧 보수 공사에 들어갈 예정이다

정답 A: 스크립트의 "Main Library, which has four floors and offers private study rooms"에서 도서관이 개인 학습실을 제공한다고 언급하고 있습니다.`,
      },
      {
        id: 3,
        question: "What does the speaker say about <mark>campus maps</mark>?",
        options: {
          A: "They can be downloaded <mark>online</mark>",
          B: "They are available at the <mark>information desk</mark>",
          C: "They will be <mark>distributed after</mark> the <mark>tour</mark>",
          D: "They include the schedule for <mark>orientation week</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 온라인으로 다운로드할 수 있다
B: 안내 데스크에서 구할 수 있다
C: 투어 후에 배부될 예정이다
D: 오리엔테이션 주간 일정이 포함되어 있다

정답 B: 스크립트의 "campus maps are available at the information desk"에서 캠퍼스 지도를 안내 데스크에서 받을 수 있다고 명시하고 있습니다.`,
      },
    ],
  },
  talk5: {
    title: "Maplewood University Tour",
    type: "tour",
    versions: {
      basic: {
        script: `Welcome, everyone, to today's tour of <mark>Maplewood University</mark>. We are excited to have you here as you explore our beautiful campus. There is a lot to see and learn, but before we begin walking around, we will first stop by the main lecture hall, where our dean, <mark>Dr. Helen Carter</mark>, will give a short welcome speech.
        <mark>Dr. Carter has been with Maplewood University for over 30 years, playing a key role in expanding our academic programs and student facilities</mark>. Many of the research centers on campus were established <mark>under her leadership</mark>.
        Now, please <mark>follow me down the main walkway to the lecture hall</mark>, where Dr. Carter is waiting for us. It's just a short distance from here.`,
        translation: `여러분, 오늘 메이플우드 대학교 투어에 오신 것을 환영합니다. 여러분이 우리의 아름다운 캠퍼스를 둘러보시게 되어 기쁩니다. 볼 것과 배울 것이 많지만, 캠퍼스를 돌아보기 전에 먼저 메인 강당에 들러 학장이신 헬렌 카터 박사님의 환영 연설을 들으실 예정입니다.
        카터 박사님은 메이플우드 대학교에서 30년 이상 재직하시면서 학술 프로그램과 학생 시설 확장에 중요한 역할을 하셨습니다. 캠퍼스 내 많은 연구 센터들이 그분의 리더십 하에 설립되었습니다.
        이제 카터 박사님이 기다리고 계신 강당으로 가는 메인 통로를 따라 저를 따라와 주세요. 여기서 그리 멀지 않습니다.`,
        audioUrl: {
          us: "audios/part4/tour/us/us5.mp3",
          uk: "audios/part4/tour/uk/uk5.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "Where are the listeners most likely?",
        options: {
          A: "At a <mark>business</mark> <mark>conference</mark>",
          B: "At a <mark>university campus</mark>",
          C: "At a research <mark>laboratory</mark>",
          D: "At a <mark>government</mark> <mark>office</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 비즈니스 컨퍼런스장에서
B: 대학 캠퍼스에서
C: 연구소에서
D: 정부 사무실에서

정답 B: 스크립트의 "Welcome, everyone, to today's tour of Maplewood University"와 "explore our beautiful campus"에서 청취자들이 대학 캠퍼스에 있다는 것을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What is mentioned about <mark>Dr. Carter</mark>?",
        options: {
          A: "She has been working at the university for <mark>over 30 years</mark>",
          B: "She recently announced her <mark>retirement</mark> plans",
          C: "She was appointed as a <mark>new department head</mark>",
          D: "She teaches in the <mark>Business School</mark>",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
        A: 그녀가 30년 이상 대학에서 근무했다
        B: 그녀가 최근 은퇴 계획을 발표했다
        C: 그녀가 새로운 학과장으로 임명되었다
        D: 그녀가 경영학부에서 강의한다
        
        정답 A: 스크립트의 "Dr. Carter has been with Maplewood University for over 30 years"에서 카터 박사가 30년 이상 대학에서 근무했다는 것을 직접적으로 언급하고 있습니다.`,
      },
      {
        id: 3,
        question: "What will the listeners most likely do next?",
        options: {
          A: "Walk to the <mark>lecture hall</mark>",
          B: "Take a tour of the <mark>library</mark>",
          C: "Visit a student <mark>dormitory</mark>",
          D: "Attend a <mark>sports event</mark>",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 강당으로 걸어가기
B: 도서관 투어하기
C: 학생 기숙사 방문하기
D: 스포츠 행사 참석하기

정답 A: 스크립트의 "follow me down the main walkway to the lecture hall"에서 다음으로 강당으로 이동할 것임을 알 수 있습니다.`,
      },
    ],
  },

  talk6: {
    title: "Chocolate Factory Tour",
    type: "tour",
    versions: {
      basic: {
        script: `Welcome to the <mark>Greenfield Chocolate Factory</mark>. My name is Daniel, and I'll be guiding you through today's tour.
        Our first stop will be the storage facility, where <mark>I'll explain how we select the finest cocoa beans and how they are transported from different countries</mark>.
        Next, we'll move on to the production floor, where you'll get to see how the beans are processed and turned into chocolate bars using our specialized machinery.
        Finally, we'll visit the tasting room, where <mark>you'll have the opportunity to sample some of our newest chocolate flavors</mark> before concluding the tour. Now, let's get started.`,
        translation: `그린필드 초콜릿 공장에 오신 것을 환영합니다. 제 이름은 다니엘이고, 오늘 투어를 안내해 드리겠습니다.
        첫 번째로 들를 곳은 저장 시설입니다. 거기서 최상급 카카오 원두를 어떻게 선별하고 여러 국가에서 어떻게 운송되는지 설명해 드리겠습니다.
        다음으로, 생산 현장으로 이동하여 원두가 어떻게 가공되어 특수 기계를 통해 초콜릿 바로 만들어지는지 보실 수 있습니다.
        마지막으로, 시식실을 방문하여 투어를 마치기 전에 저희의 최신 초콜릿 맛을 시식해 보실 수 있는 기회가 있을 것입니다. 이제 시작하겠습니다.`,
        audioUrl: {
          us: "audios/part4/tour/us/us6.mp3",
          uk: "audios/part4/tour/uk/uk6.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "Where most likely are the listeners?",
        options: {
          A: "At a <mark>bakery</mark>",
          B: "At a <mark>chocolate factory</mark>",
          C: "At a <mark>coffee shop</mark>",
          D: "At a <mark>packaging center</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 제과점에서
B: 초콜릿 공장에서
C: 커피숍에서
D: 포장 센터에서

정답 B: 스크립트의 "Welcome to the Greenfield Chocolate Factory"에서 청취자들이 초콜릿 공장에 있다는 것을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What does the speaker say he will discuss?",
        options: {
          A: "The sources of the <mark>ingredients</mark>",
          B: "The company's <mark>financial</mark> growth",
          C: "The <mark>safety</mark> <mark>regulations</mark> for employees",
          D: "The process of selling products <mark>internationally</mark> <mark>safety</mark>",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 원료의 출처
B: 회사의 재정적 성장
C: 직원들을 위한 안전 규정
D: 제품의 국제 판매 과정

정답 A: 스크립트의 "I'll explain how we select the finest cocoa beans and how they are transported from different countries"에서 원료의 출처에 대해 설명할 것임을 알 수 있습니다.`,
      },
      {
        id: 3,
        question:
          "What will the listeners be able to do at the <mark>end of the tour</mark>?",
        options: {
          A: "<mark>Purchase</mark> some products",
          B: "Try our <mark>newest chocolate flavors</mark>",
          C: "Meet a famous <mark>chocolatier</mark>",
          D: "<mark>Operate</mark> a piece of <mark>equipment</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
          A: 제품 구매하기
          B: 최신 초콜릿 맛 시도해보기
          C: 유명한 초콜릿 제조사 만나기
          D: 장비 조작해보기
          
          정답 B: 스크립트의 "you'll have the opportunity to sample some of our newest chocolate flavors"에서 투어 마지막에 최신 초콜릿 맛을 시식할 수 있다는 것을 알 수 있습니다.`,
      },
    ],
  },
  talk7: {
    title: "Eiffel Tower Tour",
    type: "tour",
    versions: {
      basic: {
        script: `Good afternoon, everyone, and <mark>welcome to your guided tour of the Eiffel Tower</mark>. My name is Sophie, and I'll be your tour guide today.
        We will begin by taking the elevator <mark>up to the second level</mark>, where you'll get a breathtaking view of Paris. You will have 30 minutes to walk around, take pictures, and visit the souvenir shop. <mark>After that, we will continue to the summit, which stands at 276 meters high</mark>. Please note that the summit can get quite windy, so hold onto your belongings.
        <mark>At the end of the tour, we will meet back at the main entrance at 3 PM</mark>. If you have any questions, feel free to ask me during the tour. Now, let's get started!`,
        translation: `안녕하세요 여러분, 에펠탑 가이드 투어에 오신 것을 환영합니다. 제 이름은 소피이고, 오늘 여러분의 투어 가이드를 맡게 되었습니다.
        우리는 먼저 엘리베이터를 타고 2층으로 올라가 파리의 멋진 전망을 감상하실 수 있습니다. 30분 동안 주변을 둘러보고, 사진도 찍고, 기념품 가게도 방문하실 수 있습니다. 그 후에는 276미터 높이의 정상으로 이동할 예정입니다. 정상은 바람이 꽤 강할 수 있으니 소지품을 잘 붙잡아 주시기 바랍니다.
        투어가 끝나면 오후 3시에 메인 입구에서 다시 만나겠습니다. 투어 중에 질문이 있으시면 언제든 저에게 말씀해 주세요. 이제 시작하겠습니다!`,
        audioUrl: {
          us: "audios/part4/tour/us/us7.mp3",
          uk: "audios/part4/tour/uk/uk7.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the purpose of the announcement?",
        options: {
          A: "To explain the <mark>history</mark> of a monument",
          B: "To give instructions for a <mark>guided tour</mark>",
          C: "To provide <mark>safety guidelines</mark> for tourists",
          D: "To advertise an upcoming <mark>sightseeing event</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
  A: 기념물의 역사를 설명하기 위해
  B: 가이드 투어에 대한 지시를 제공하기 위해
  C: 관광객을 위한 안전 지침을 제공하기 위해
  D: 다가오는 관광 이벤트를 홍보하기 위해
  
  정답 B: 스크립트의 "welcome to your guided tour of the Eiffel Tower"에서 이 안내는 에펠탑 가이드 투어에 대한 지시를 제공하기 위한 것임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question:
          "What advice is given about <mark>visiting the summit</mark>?",
        options: {
          A: "Wear <mark>warm clothing</mark>",
          B: "Take panoramic <mark>photographs</mark>",
          C: "Hold onto your <mark>belongings</mark>",
          D: "Stay for <mark>no more than 15 minutes</mark>",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
        A: 따뜻한 옷을 입으라
        B: 파노라마 사진을 찍으라
        C: 소지품을 잘 붙잡으라
        D: 15분 이상 머물지 말라
        
        정답 C: 스크립트의 "Please note that the summit can get quite windy, so hold onto your belongings"에서 정상에 바람이 강할 수 있으니 소지품을 잘 붙잡으라고 조언하고 있습니다.`,
      },
      {
        id: 3,
        question: "Where will the tour group meet at the end?",
        options: {
          A: "At the <mark>ticket counter</mark>",
          B: "At the <mark>souvenir shop</mark>",
          C: "At the <mark>main entrance</mark>",
          D: "At a nearby <mark>bus stop</mark>",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
  A: 티켓 카운터에서
  B: 기념품 상점에서
  C: 메인 입구에서
  D: 근처 버스 정류장에서
  
  정답 C: 스크립트의 "At the end of the tour, we will meet back at the main entrance at 3 PM"에서 투어 끝에 메인 입구에서 만날 것임을 알 수 있습니다.`,
      },
    ],
  },

  talk8: {
    title: "Grand Canyon National Park Tour",
    type: "tour",
    versions: {
      basic: {
        script: `Good morning, everyone, and <mark>welcome to Grand Canyon National Park. My name is Lisa, and I will be your tour guide today</mark>.
        We are currently standing at Mather Point, one of the most popular viewpoints in the park. From here, you can enjoy a breathtaking panoramic view of the canyon, which stretches over 446 kilometers in length. <mark>The Colorado River, which carved this magnificent landscape over millions of years</mark>, is visible in the distance.
        Next, we will take a short hike along the Rim Trail, which offers even more incredible views. Please remember to stay on the designated path and bring plenty of water, as temperatures can get quite high. <mark>At the end of the tour, we will return to the visitor center at 4 PM</mark>. Now, let's begin our journey!`,
        translation: `안녕하세요 여러분, 그랜드 캐니언 국립공원에 오신 것을 환영합니다. 제 이름은 리사이고, 오늘 여러분의 투어 가이드를 맡게 되었습니다.
        우리는 현재 공원에서 가장 인기 있는 전망대 중 하나인 매더 포인트에 서 있습니다. 여기서 446킬로미터에 달하는 협곡의 멋진 파노라마 전경을 감상하실 수 있습니다. 수백만 년에 걸쳐 이 장엄한 풍경을 만들어낸 콜로라도 강이 멀리서 보입니다.
        다음으로, 더 멋진 전망을 제공하는 림 트레일을 따라 짧은 하이킹을 할 예정입니다. 기온이 꽤 높을 수 있으니 지정된 길에서 벗어나지 마시고 충분한 물을 가져오시기 바랍니다. 투어가 끝나면 오후 4시에 방문자 센터로 돌아갈 예정입니다. 이제 우리의 여정을 시작하겠습니다!`,
        audioUrl: {
          us: "audios/part4/tour/us/us8.mp3",
          uk: "audios/part4/tour/uk/uk8.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the purpose of the tour guide's introduction?",
        options: {
          A: "To explain the <mark>history</mark> of a national park",
          B: "To describe a famous <mark>rock formation</mark>",
          C: "To introduce a <mark>guided tour</mark>",
          D: "To warn visitors about <mark>safety rules</mark>",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
      A: 국립공원의 역사를 설명하기 위해
      B: 유명한 암석 형성물을 설명하기 위해
      C: 가이드 투어를 소개하기 위해
      D: 방문객들에게 안전 규칙을 경고하기 위해
      
      정답 C: 스크립트의 "welcome to Grand Canyon National Park. My name is David, and I will be your tour guide today"에서 이 안내는 그랜드 캐니언 국립공원의 가이드 투어를 소개하기 위한 것임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What is mentioned about the <mark>Grand Canyon</mark>?",
        options: {
          A: "It is the <mark>largest canyon</mark> in the world",
          B: "It was formed by an <mark>earthquake</mark>",
          C: "It was shaped by the <mark>Colorado River</mark><mark>over time</mark>",
          D: "It is <mark>only</mark> accessible by <mark>hiking trails</mark>",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
  A: 세계에서 가장 큰 협곡이다
  B: 지진에 의해 형성되었다
  C: 시간이 지남에 따라 콜로라도 강에 의해 형성되었다
  D: 하이킹 트레일을 통해서만 접근할 수 있다
  
  정답 C: 스크립트의 "The Colorado River, which carved this magnificent landscape over millions of years"에서 그랜드 캐니언이 콜로라도 강에 의해 수백만 년에 걸쳐 형성되었다고 언급하고 있습니다.`,
      },
      {
        id: 3,
        question:
          "Where will the group go at the <mark>end of the tour</mark>?",
        options: {
          A: "To a <mark>museum</mark>",
          B: "To the <mark>visitor center</mark>",
          C: "To a <mark>campsite</mark>",
          D: "To a nearby <mark>town</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
  A: 박물관으로
  B: 방문자 센터로
  C: 캠프장으로
  D: 근처 마을로
  
  정답 B: 스크립트의 "At the end of the tour, we will return to the visitor center at 4 PM"에서 투어 끝에 방문자 센터로 돌아갈 것임을 알 수 있습니다.`,
      },
    ],
  },

  talk9: {
    title: "Downtown Sightseeing Bus Tour",
    type: "tour",
    versions: {
      basic: {
        script: `Good afternoon, everyone! <mark>Welcome to the Downtown Sightseeing Bus Tour. My name is Jake, and I'll be your guide for today's journey through the city's most famous landmarks</mark>.
        <mark>Our first stop will be Central Square</mark>, where you'll have 30 minutes to explore the historic district and take photos. After that, we'll drive along Riverside Avenue, a scenic route known for its waterfront cafes and beautiful skyline views.
        <mark>At the end of the tour, we will return to Grand Station</mark>, where you can continue your day in the city or transfer to other transportation options. If you have any questions during the tour, feel free to ask. Now, let's get started!`,
        translation: `안녕하세요 여러분! 다운타운 관광 버스 투어에 오신 것을 환영합니다. 제 이름은 제이크이고, 오늘 도시의 가장 유명한 명소들을 둘러보는 여정의 가이드를 맡게 되었습니다.
        첫 번째 정류장은 센트럴 스퀘어입니다. 이곳에서 30분 동안 역사 지구를 둘러보고 사진을 찍으실 수 있습니다. 그 후에는 워터프론트 카페와 아름다운 스카이라인 전망으로 유명한 경관 도로인 리버사이드 애비뉴를 따라 이동할 예정입니다.
        투어가 끝나면 그랜드 스테이션으로 돌아갈 예정이며, 그곳에서 도시에서의 일정을 계속하시거나 다른 교통수단으로 갈아타실 수 있습니다. 투어 중에 질문이 있으시면 언제든 말씀해 주세요. 이제 시작하겠습니다!`,
        audioUrl: {
          us: "audios/part4/tour/us/us9.mp3",
          uk: "audios/part4/tour/uk/uk9.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the purpose of this tour guide's introduction?",
        options: {
          A: "To introduce a <mark>city tour route</mark>",
          B: "To explain public transportation <mark>fares</mark>",
          C: "To give <mark>safety instructions</mark> for passengers",
          D: "To advertise <mark>a new museum exhibition</mark>",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
      A: 도시 투어 경로를 소개하기 위해
      B: 대중교통 요금을 설명하기 위해
      C: 승객들에게 안전 지침을 제공하기 위해
      D: 새로운 박물관 전시회를 홍보하기 위해
      
      정답 A: 스크립트의 "Welcome to the Downtown Sightseeing Bus Tour. My name is Jake, and I'll be your guide for today's journey through the city's most famous landmarks"에서 이 소개가 도시 투어 경로를 안내하기 위한 것임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "Where will the <mark>first stop</mark> be?",
        options: {
          A: "At <mark>Grand Station</mark>",
          B: "At <mark>Riverside Avenue</mark>",
          C: "At a local <mark>shopping district</mark>",
          D: "At <mark>Central Square</mark>",
        },
        correctAnswer: "D",
        explanation: `[선택지 해석]
  A: 그랜드 스테이션에서
  B: 리버사이드 애비뉴에서
  C: 지역 쇼핑 지구에서
  D: 센트럴 스퀘어에서
  
  정답 D: 스크립트의 "Our first stop will be Central Square"에서 첫 번째 정류장이 센트럴 스퀘어임을 명확히 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "Where will the <mark>tour end</mark>?",
        options: {
          A: "At the <mark>entrance of a park</mark>",
          B: "At a <mark>famous restaurant</mark>",
          C: "At a <mark>large shopping mall</mark>",
          D: "At <mark>Grand Station</mark>",
        },
        correctAnswer: "D",
        explanation: `[선택지 해석]
  A: 공원 입구에서
  B: 유명한 레스토랑에서
  C: 대형 쇼핑몰에서
  D: 그랜드 스테이션에서
  
  정답 D: 스크립트의 "At the end of the tour, we will return to Grand Station"에서 투어가 그랜드 스테이션에서 끝날 것임을 알 수 있습니다.`,
      },
    ],
  },

  talk10: {
    title: "Grand Art Gallery Tour: Monet's Masterpieces",
    type: "tour",
    versions: {
      basic: {
        script: `Good afternoon, everyone, and welcome to the <mark>Grand Art Gallery</mark>. My name is Lisa, and I'll be <mark>guiding you through today's special exhibition, Monet's Masterpieces</mark>.
        This collection features <mark>over 40 original works by Claude Monet</mark>, including some of his most famous paintings, such as Water Lilies and Impression, Sunrise. These pieces are on loan from various museums around the world and will be displayed here until October 15th.
        Please note that photography is not allowed inside the exhibit. At the end of the tour, we will <mark>gather in the gallery's gift shop</mark>, where you can find exclusive exhibition catalogs and souvenirs. Now, let's begin!`,
        translation: `안녕하세요 여러분, 그랜드 아트 갤러리에 오신 것을 환영합니다. 제 이름은 리사이고, 오늘 특별 전시회인 '모네의 걸작들'을 안내해 드리겠습니다.
        이 컬렉션은 '수련'과 '인상, 해돋이'와 같은 가장 유명한 작품들을 포함하여 클로드 모네의 40점 이상의 원작을 선보입니다. 이 작품들은 전 세계 여러 박물관에서 대여한 것으로 10월 15일까지 전시될 예정입니다.
        전시장 내에서는 사진 촬영이 금지되어 있습니다. 투어가 끝나면 갤러리 기프트샵에 모일 예정이며, 그곳에서 전시회 전용 도록과 기념품을 구매하실 수 있습니다. 이제 시작하겠습니다!`,
        audioUrl: {
          us: "audios/part4/tour/us/us10.mp3",
          uk: "audios/part4/tour/uk/uk10.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the speaker mainly discussing?",
        options: {
          A: "A new art course for <mark>beginners</mark>",
          B: "A history lecture on <mark>Impressionism</mark>",
          C: "A <mark>special exhibition</mark> at an art gallery",
          D: "A guided tour of a <mark>sculpture museum</mark>",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
  A: 초보자를 위한 새로운 미술 강좌
  B: 인상주의에 관한 역사 강의
  C: 미술 갤러리의 특별 전시회
  D: 조각 박물관의 가이드 투어
  
  정답 C: 스크립트의 "welcome to the Grand Art Gallery. My name is Lisa, and I'll be guiding you through today's special exhibition, Monet's Masterpieces"에서 화자가 미술 갤러리의 특별 전시회에 대해 주로 설명하고 있음을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What is mentioned about the exhibition?",
        options: {
          A: "It will last for <mark>six months</mark>",
          B: "It includes <mark>modern digital art</mark>",
          C: "It features paintings by <mark>Claude Monet</mark>",
          D: "It is open <mark>only to art students</mark>",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
  A: 6개월 동안 지속될 것이다
  B: 현대 디지털 아트를 포함한다
  C: 클로드 모네의 그림들을 특징으로 한다
  D: 미술 학생들에게만 개방되어 있다
  
  정답 C: 스크립트의 "This collection features over 40 original works by Claude Monet, including some of his most famous paintings"에서 전시회가 클로드 모네의 작품을 특징으로 한다고 언급하고 있습니다.`,
      },
      {
        id: 3,
        question: "Where will the tour group meet at the <mark>end</mark>?",
        options: {
          A: "At the <mark>museum entrance</mark>",
          B: "In front of the <mark>main hall</mark>",
          C: "In the gallery's <mark>gift shop</mark>",
          D: "At a nearby <mark>café</mark>",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
  A: 박물관 입구에서
  B: 메인 홀 앞에서
  C: 갤러리의 기프트숍에서
  D: 근처 카페에서
  
  정답 C: 스크립트의 "At the end of the tour, we will gather in the gallery's gift shop"에서 투어가 끝날 때 그룹이 갤러리 기프트숍에서 모일 것임을 알 수 있습니다.`,
      },
    ],
  },

  talk11: {
    title: "Venice Gondola Experience",
    type: "tour",
    versions: {
      basic: {
        script: `Good afternoon, everyone! Welcome to the Venice Gondola Experience. My name is Marco, and I will be <mark>your gondolier for this journey through the beautiful canals of Venice</mark>.
        As we begin, you'll notice <mark>the Rialto Bridge, the oldest and most famous bridge in the city, built in the late 16th century</mark>. Along the way, we'll pass by historical palaces that once belonged to noble Venetian families.
        Please remain seated throughout the ride, and feel free to take photos, but keep your belongings secure, as some canals are quite narrow. At the end of our tour, you can enjoy <mark>a complimentary glass of Italian wine at the dockside café</mark>. Now, sit back and enjoy the ride!`,
        translation: `안녕하세요 여러분! 베니스 곤돌라 체험에 오신 것을 환영합니다. 제 이름은 마르코이고, 베니스의 아름다운 운하를 통과하는 이 여정의 곤돌라 선장을 맡게 되었습니다.
        시작하면서 16세기 후반에 지어진, 도시에서 가장 오래되고 유명한 다리인 리알토 다리를 보실 수 있습니다. 여정 중에 베네치아 귀족 가문들이 소유했던 역사적인 궁전들을 지나갈 예정입니다.
        승선 중에는 자리에 앉아 계시고, 사진 촬영은 자유롭게 하실 수 있지만 일부 운하가 매우 좁으니 소지품을 잘 지켜주시기 바랍니다. 투어가 끝나면 부두 카페에서 이탈리아 와인 한 잔을 무료로 즐기실 수 있습니다. 이제 편안히 앉아서 여행을 즐기시기 바랍니다!`,
        audioUrl: {
          us: "audios/part4/tour/us/us11.mp3",
          uk: "audios/part4/tour/uk/uk11.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the speaker mainly talking about?",
        options: {
          A: "A tour of famous <mark>Italian restaurants</mark>",
          B: "A <mark>bus ride</mark> through the streets of Venice",
          C: "A <mark>gondola ride</mark> through the city's canals",
          D: "A <mark>walking tour</mark> of historical landmarks",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
  A: 유명한 이탈리아 레스토랑 투어
  B: 베니스 거리를 통과하는 버스 여행
  C: 도시 운하를 통과하는 곤돌라 여행
  D: 역사적 명소를 둘러보는 도보 투어
  
  정답 C: 스크립트의 "Welcome to the Venice Gondola Experience. My name is Marco, and I will be your gondolier for this journey through the beautiful canals of Venice"에서 곤돌라를 타고 베니스 운하를 여행하는 투어임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What is mentioned about the <mark>Rialto Bridge</mark>?",
        options: {
          A: "It was built in the <mark>19th century</mark>",
          B: "It is the <mark>longest bridge</mark> in Italy",
          C: "It is the <mark>oldest bridge</mark> in Venice",
          D: "It <mark>connects Venice</mark> to the mainland",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
  A: 19세기에 지어졌다
  B: 이탈리아에서 가장 긴 다리이다
  C: 베니스에서 가장 오래된 다리이다
  D: 베니스와 본토를 연결한다
  
  정답 C: 스크립트의 "the Rialto Bridge, the oldest and most famous bridge in the city, built in the late 16th century"에서 리알토 다리가 베니스에서 가장 오래된 다리라고 언급하고 있습니다.`,
      },
      {
        id: 3,
        question:
          "What will passengers receive at the <mark>end of the tour</mark>?",
        options: {
          A: "A free souvenir from the <mark>gift shop</mark>",
          B: "A complimentary <mark>glass of wine</mark>",
          C: "A <mark>discount</mark> on their next boat ride",
          D: "A guided tour of a nearby <mark>museum</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
  A: 기념품 상점에서 무료 기념품
  B: 무료 와인 한 잔
  C: 다음 보트 승선 할인
  D: 근처 박물관 가이드 투어
  
  정답 B: 스크립트의 "At the end of our tour, you can enjoy a complimentary glass of Italian wine at the dockside café"에서 투어 끝에 무료 와인을 제공받는다고 언급하고 있습니다.`,
      },
    ],
  },

  talk12: {
    title: "Wine Tour: Bordeaux Vineyard Experience",
    type: "tour",
    versions: {
      basic: {
        script: `Good afternoon, everyone, and <mark>welcome to the Bordeaux Vineyard Experience. My name is Pierre, and I'll be guiding you through today's tour of this world-renowned winery</mark>.
        We will begin with a visit to the grape fields, where you'll learn about different grape varieties used in Bordeaux wines. <mark>Then, we'll move to the barrel-aging room, where the wine is stored in oak barrels to develop its rich flavor</mark>. Finally, you'll get to sample some of our finest wines, including our signature Cabernet Sauvignon blend.
        <mark>At the end of the tour, you'll have the opportunity to purchase bottles directly from the vineyard at a special discount</mark>. Now, let's head to the grape fields and start our tour!`,
        translation: `안녕하세요 여러분, 보르도 포도원 체험에 오신 것을 환영합니다. 제 이름은 피에르이고, 오늘 이 세계적으로 유명한 와이너리 투어를 안내해 드리겠습니다.
        먼저 포도밭을 방문하여 보르도 와인에 사용되는 다양한 포도 품종에 대해 배우실 것입니다. 그 다음에는 와인이 풍부한 맛을 내기 위해 오크통에서 숙성되는 배럴 숙성실로 이동하겠습니다. 마지막으로 우리의 시그니처 카베르네 소비뇽 블렌드를 포함한 최고급 와인들을 시음하실 수 있습니다.
        투어가 끝나면 특별 할인가로 포도원에서 직접 와인을 구매하실 수 있는 기회가 있습니다. 이제 포도밭으로 가서 투어를 시작하겠습니다!`,
        audioUrl: {
          us: "audios/part4/tour/us/us12.mp3",
          uk: "audios/part4/tour/uk/uk12.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the speaker introducing?",
        options: {
          A: "A guided tour of a <mark>winery</mark>",
          B: "A cooking class for <mark>beginners</mark>",
          C: "A lecture on <mark>French wine history</mark>",
          D: "A festival celebrating <mark>wine production</mark>",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
  A: 와이너리 가이드 투어
  B: 초보자를 위한 요리 수업
  C: 프랑스 와인 역사에 관한 강의
  D: 와인 생산을 축하하는 페스티벌
  
  정답 A: 스크립트의 "welcome to the Bordeaux Vineyard Experience. My name is Pierre, and I'll be guiding you through today's tour of this world-renowned winery"에서 이 안내가 와이너리 가이드 투어를 소개하는 것임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question:
          "What will visitors do at the <mark>barrel-aging room</mark>?",
        options: {
          A: "Learn how wine develops its <mark>flavor</mark>",
          B: "Pick <mark>grapes</mark> for wine production",
          C: "Meet the <mark>vineyard's head winemaker</mark>",
          D: "Participate in a wine blending <mark>workshop</mark>",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
  A: 와인이 어떻게 맛을 발전시키는지 배우기
  B: 와인 생산을 위한 포도 따기
  C: 포도원의 수석 와인메이커 만나기
  D: 와인 블렌딩 워크숍에 참여하기
  
  정답 A: 스크립트의 "Then, we'll move to the barrel-aging room, where the wine is stored in oak barrels to develop its rich flavor"에서 배럴 숙성실에서 와인이 어떻게 풍부한 맛을 발전시키는지 배울 것임을 알 수 있습니다.`,
      },
      {
        id: 3,
        question:
          "What will visitors have a chance to do at the <mark>end of the tour</mark>?",
        options: {
          A: "Purchase wine at a <mark>discount</mark>",
          B: "Receive a <mark>free</mark> bottle of <mark>wine</mark>",
          C: "Take home a souvenir <mark>glass</mark>",
          D: "Try <mark>making</mark> their own <mark>wine</mark>",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
  A: 할인된 가격으로 와인 구매하기
  B: 무료 와인 한 병 받기
  C: 기념품 유리잔 가져가기
  D: 직접 와인 만들기 시도하기
  
  정답 A: 스크립트의 "At the end of the tour, you'll have the opportunity to purchase bottles directly from the vineyard at a special discount"에서 투어가 끝나면 특별 할인가로 와인을 구매할 수 있는 기회가 있음을 알 수 있습니다.`,
      },
    ],
  },
};
